import React from 'react';
import { Box } from '@mui/material';
import { renderFormattedText } from '../utils/textFormatting';

const FormattedTextDisplay = ({ 
  formattedText, 
  sx = {},
  ...props 
}) => {
  const htmlContent = renderFormattedText(formattedText);

  return (
    <Box
      sx={{
        fontFamily: 'NanumSquareR, sans-serif',
        fontWeight: 500,
        fontSize: { xs: 15, sm: 17, md: 18 },
        letterSpacing: '0.02em',
        lineHeight: { xs: 1.7, sm: 1.7, md: 1.7 },
        color: '#000000',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        background: 'transparent',
        minHeight: 0,
        '& strong': {
          fontFamily: "'NanumSquareB', 'NanumSquare', sans-serif",
          fontWeight: 'bold',
          fontStyle: 'normal'
        },
        '& span[style*="font-size"]': {
          lineHeight: 'auto',
          fontStyle: 'normal'
        },
        // 줄바꿈 처리
        '& br': {
          display: 'block',
          content: '""',
          marginTop: '0.5em'
        },
        ...sx
      }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      {...props}
    />
  );
};

export default FormattedTextDisplay;
